<div class="flex flex-row flex-wrap p-4 gap-2">
    <div class="items-center p-2 w-fit">
        <ng-icon name="faSolidFilter" size="16" color="#CC4A1E"></ng-icon>
    </div>
    @for(tag of tags(); track $index) {
    <div class="rounded filter" [ngClass]="{ 'bg-background-dark text-secondary': selectedTags.includes(tag) }"
        (click)="onTagClicked(tag)">
        <app-glossary-tag [text]="tag"></app-glossary-tag>
    </div>
    }
</div>